import { BaseListViewStore, OrderLinesHyperlinkCellData, checkPermissions, MultipleCellData } from 'core/stores';
import { observable, action, reaction, makeObservable } from 'mobx';
import { FulfillmentOrderStore } from 'modules/order/stores';
import { OrderLineStore } from 'modules/order-line/stores';
import { TableFilterUtility } from 'core/utils';
import { ModalParams, ConfirmModalParams } from 'core/models';
import { LookupStore } from 'modules/lookup/stores';
import { notificationError } from 'core/utils';
import { channelType, sourceOfChange } from 'common/constants';
import _ from 'lodash';

class OrderLinesListViewStore extends BaseListViewStore {
	@observable change = false;
	showActions = false;
	noDataItem = true;
	hasPiiAccess = false;

	constructor(rootStore, componentProps) {
		super(rootStore, {
			listStore: new FulfillmentOrderStore(rootStore),
			queryParams: {
				embed: [],
				filter: null,
				ignore: true,
			},

			tableData: {
				columns: [
					{
						key: 'sku',
						title: 'ORDERLINEVIEW.SKU',
						selected: true,
						width: 200,
						filter: null,
						dataCell: OrderLinesHyperlinkCellData,
						onClick: item => this.routes.detail(item.id),
						propertyToCheck: 'product',
						translation: 'ORDERLINEVIEW.UNLINKEDORDERLINE',
					},
					{
						key: 'product.productUpcs.upc',
						title: 'ORDERLINEVIEW.UPC',
						dataCell: MultipleCellData,
						selected: true,
						width: 200,
						filter: null,
						isOrderLineView: true,
					},
					{
						key: 'quantity',
						title: 'ORDERLINEVIEW.QUANTITY',
						selected: true,
						width: 200,
						filter: null,
					},
					{
						key: 'unitPrice',
						title: 'ORDERLINEVIEW.UNITPRICE',
						selected: true,
						width: 200,
						filter: null,
					},
					{
						key: 'discount',
						title: 'Discount',
						selected: true,
						width: 200,
						filter: null,
					},
					{
						key: 'orderLineStatus.name',
						title: 'ORDERLINEVIEW.STATUS',
						selected: true,
						width: 200,
						filter: null,
					},
				],
				sortObject: [],
				actions: {
					onLinkOrderLine: async orderLine => this.linkOrderLineModal.open(orderLine),
					onRefundOrderLine: async orderLine => this.openRefundOrderLineConfirmModal(orderLine),
				},
			},
			permissions: {
				update: () => this.authStore.hasPermission('marketplaceOrderSection.update'),
				create: () => this.authStore.hasPermission('marketplaceOrderSection.create'),
				remove: () => this.authStore.hasPermission('marketplaceOrderSection.delete'),
				read: () => this.authStore.hasPermission('marketplaceOrderSection.read'),
				full: () => this.authStore.hasPermission('marketplaceOrderSection.full'),
			},
			routes: {
				detail: id =>
					this.rootStore.routerStore.goTo('master.app.main.product.list.detail', {
						id,
					}),
			},
		});
		makeObservable(this);
		this.queryUtility.initialize(this.findOrderLines);
		this.tableFilter = new TableFilterUtility({
			lookupStore: new LookupStore(rootStore),
			listStore: this.listStore,
			queryUtility: this.queryUtility,
			columns: this.tableData.columns,
			service: this.listStore.service,
		});
		this.orderLineStore = new OrderLineStore(rootStore);
		this.hasPiiAccess = this.rootStore.authStore.hasPiiAccess;
		this.isChannelAmazon =
			componentProps.channel != null ? componentProps.channel.channelType.name == channelType.amazon : null;
		this.hasAllFOsPastExitScan = componentProps.hasAllFOsPastExitScan;
		this.showActions = checkPermissions(this).actionsAllowed;
	}

	@action.bound
	openRefundOrderLineConfirmModal = item => {
		this.selectedItem = item;
		this.refundOrderLineConfirmModal.open({
			message: ['ORDERVIEW.REFUNDORDERLINECONFIRM'],
		});
	};

	refundOrderLineConfirmModal = new ConfirmModalParams({
		onConfirm: async () => {
			await this.refundOrderLine();
		},
	});

	@action.bound
	refundOrderLine = async () => {
		this.suspend();
		try {
			const {
				data: { total, canceled, refunded, message },
			} = await this.orderLineStore.refundOrderLine(this.selectedItem.id, sourceOfChange.refundOrderLine);
			if (message) {
				this.rootStore.notificationStore.error(message);
			} else {
				this.rootStore.notificationStore.success([
					'ORDERVIEW.REFUNDORDERLINESSUCCESS',
					{ total, refunded, failed: total - (canceled + refunded) },
				]);
				await this.queryUtility.initialize(false);
			}
		} catch (err) {
			notificationError({ store: this.rootStore.notificationStore, err });
		}
		this.resume();
	};

	@action.bound
	closeModal = () => {
		this.linkOrderLineModal.close();
	};

	@action.bound setAsChanged() {
		this.change = !this.change;
	}

	@action.bound async findOrderLines() {}

	linkOrderLineModal = new ModalParams({
		onClose: this.closeModal,
	});
}

export default OrderLinesListViewStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/OrderLinesListViewStore.js